import { plainToInstance } from 'class-transformer'

import { GET_MY_PURCHASED_BOOK_LISTS } from '@client/collections/MyReading/schemas/getBookPurchaseList'
import { GET_MY_PURCHASED_BOOK } from '@client/collections/MyReading/schemas/getMyPurchasedBook'
import { GET_MY_SHELF } from '@client/collections/MyReading/schemas/getMyShelf'
import { GET_STATUS_SHELF } from '@client/collections/MyReading/schemas/getStatusShelf'
import { UPDATE_SHELF } from '@client/collections/MyReading/schemas/updateShelf'
import { SearchParamsType } from '@interfaces/BookShelveType'
import { BookPurchaseType } from '@models/myReading/BookPurchaseType'
import { BookShelfResponse } from '@models/myReading/BookShelfResponse'
import { gqlApiInstance } from '@client/init'
import { BookShelfStatusType } from '@models/book/BookShelfStatusType'

export function useMyReadingAction() {
  async function getMyShelf(
    page: number,
    limitPerPage: number,
    searchParam: SearchParamsType
  ): Promise<BookShelfResponse> {
    const res = await gqlApiInstance.request(GET_MY_SHELF, {
      page,
      limitPerPage,
      bookType: searchParam.bookType?.length ? searchParam.bookType : null,
      chapterType: null,
      categoryIds: searchParam.categoryId
        ? [Number(searchParam.categoryId)]
        : null,
      shelfBookDisplay: searchParam.display,
      shelfBookOrder: searchParam.sort,
      searchText: searchParam.text,
      isEbook: null,
    })

    return plainToInstance(BookShelfResponse, {
      ...res.getMyShelf,
      data: res.getMyShelf.data.map((row: any) => row.book),
    })
  }

  async function updateMyShelf(params: { bookId: number; action: string }) {
    return gqlApiInstance.request(UPDATE_SHELF, {
      updateShelfInput: { ...params },
    })
  }

  async function getStatusShelf(bookId: number): Promise<BookShelfStatusType> {
    return gqlApiInstance.request(GET_STATUS_SHELF, { bookId })
  }

  async function getMyPurchasedBookLists(
    page: number,
    limitPerPage: number,
    searchParam: SearchParamsType
  ): Promise<BookShelfResponse> {
    const res = await gqlApiInstance.request(GET_MY_PURCHASED_BOOK_LISTS, {
      page,
      limitPerPage,
      bookType: searchParam.bookType?.length ? searchParam.bookType : null,
      chapterType: null,
      categoryIds: searchParam.categoryId
        ? [Number(searchParam.categoryId)]
        : null,
      shelfBookDisplay: searchParam.display,
      searchText: searchParam.text,
      isEbook: null,
    })

    return plainToInstance(BookShelfResponse, res.getMyPurchasedBookLists)
  }

  async function getMyPurchasedBook(bookId: number): Promise<BookPurchaseType> {
    const res = await gqlApiInstance.request(GET_MY_PURCHASED_BOOK, { bookId })

    return plainToInstance(BookPurchaseType, res.getMyPurchasedBook)
  }

  return {
    getMyShelf,
    updateMyShelf,
    getStatusShelf,
    getMyPurchasedBookLists,
    getMyPurchasedBook,
  }
}
